export async function fetchRoute(coordinates, profile = "driving") {
  // coordinates: [[lng, lat], [lng, lat], [lng, lat]]
  const coordsStr = coordinates.map(c => `${c[0]},${c[1]}`).join(";");

  const url =
    `https://api.mapbox.com/directions/v5/mapbox/${profile}/${coordsStr}` +
    `?geometries=geojson&overview=full&access_token=${process.env.REACT_APP_MAPBOX_TOKEN}`;

  const res = await fetch(url);

  if (!res.ok) throw new Error(`Directions API error: ${res.status}`);
  const json = await res.json();

  const route = json.routes?.[0]?.geometry; // GeoJSON LineString
  if (!route) throw new Error("No route returned");

  return {
    type: "Feature",
    geometry: route,
    properties: {},
  };
}